export function cleanUpImagePath(path: string) {
  if (path.startsWith('/')) {
    return path.slice(1);
  }
  return path;
}
export function cleanUpImagesUrl(images: { [k: string]: any }) {
  if (!images) {
    return images;
  }

  for (const [key, image] of Object.entries(images)) {
    image.path = cleanUpImagePath(image.path);
  }
  return images;
}
